export default __webpack_public_path__ + "static/media/extra4.7b77738a.png";